import { createAction } from 'redux-actions';

export const SET_THEME_COLOR = createAction('SET_THEME_COLOR');
